<template>
  <DsShowcase title="ImagePickerPlay" description="Seletor de imagem com preview, estados e dimensões customizáveis.">
    <!-- PROP: h / w -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">h / w</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — altura e largura CSS. Padrão: <code>h='160px'</code>, <code>w='100%'</code></p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap">
        <ImagePickerPlay h="120px" w="120px" />
        <ImagePickerPlay h="160px" w="200px" />
        <ImagePickerPlay h="200px" w="300px" />
      </div>
    </section>

    <!-- PROP: icon / placeholder -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">icon / placeholder</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>icon: string</code> — ícone Material Symbols. <code>placeholder: string</code> — texto exibido no estado vazio.</p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap">
        <ImagePickerPlay h="140px" w="200px" icon="add_photo_alternate" placeholder="Foto de capa" />
        <ImagePickerPlay h="140px" w="200px" icon="upload" placeholder="Upload de banner" />
        <ImagePickerPlay h="140px" w="200px" icon="image" placeholder="Selecionar imagem" />
      </div>
    </section>

    <!-- PROP: src / fit -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">src / fit</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>src: string</code> — URL da imagem. <code>fit: 'contain' | 'cover'</code> — object-fit. Padrão: <code>contain</code></p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap">
        <ImagePickerPlay h="160px" w="240px" src="https://picsum.photos/400/300" fit="contain" placeholder="contain" />
        <ImagePickerPlay h="160px" w="240px" src="https://picsum.photos/400/300" fit="cover" placeholder="cover" />
      </div>
    </section>

    <!-- PROP: error -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">error</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — borda vermelha</p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap">
        <ImagePickerPlay h="140px" w="200px" :error="true" placeholder="Campo obrigatório" />
      </div>
    </section>

    <!-- PROP: disabled / skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled / skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap">
        <ImagePickerPlay h="140px" w="200px" :disabled="true" src="https://picsum.photos/400/300" />
        <ImagePickerPlay h="140px" w="200px" :skeleton="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { ImagePickerPlay } from '@/components/atomic'
</script>
